import React from "react";
import { Link } from "react-router-dom";
import Select from "react-select";
import Context from "../../../Context";
import EssenceReferenceSchedulerEdit from "../../Essence/EssenceReferenceSchedulerEdit";
import Blocker from "../../Misc/Blocker";
import DefaultNotFound from "../../Misc/DefaultNotFound";
import SuperSelect from "../../Misc/SuperSelect";
export default class MaintEdit extends React.Component {
  static contextType = Context;
  constructor(props) {
    super(props);
    this.state = {
      item: {},
      notFound: false,
      pending: false,
      structItems: {},
    };
  }

  componentDidMount() {
    this.loadReferences().then(() => this.load());
  }

  componentDidUpdate(prevProps) {
    if (prevProps.itemId !== this.props.itemId) {
      this.load();
    }
  }

  onChange = (id, value) => {
    this.setState((state) => {
      let { item } = state;
      item[id] = value;
      return { item };
    });
  };

  loadReferences = async () => {};

  load = async () => {
    this.setState({ pending: true });
    let itemQuery = {};
    if (this.props.itemId !== "add") {
      itemQuery = await this.context.api.q("/maintenance/get", {
        id: this.props.itemId,
      });
    } else {
      itemQuery = {
        id: "add",
        ship:
          this.props.shipId !== "any"
            ? this.props.shipId
            : this.context.api.nullUuid,
      };
    }

    let structItems = await this.context.api.qoo(
      `/structure/list`,
      {
        search: [
          {
            lstr: "(",
            field: "statetypecode",
            compare: "EQL",
            value: "enabled",
          },
          {
            field: "typecode",
            compare: "EQL",
            value: "maintenance.structure",
            rstr: ")",
          },
        ],
      },
      undefined,
      undefined,
      undefined,
      "node",
      "sequence"
    );

    this.setState({
      pending: false,
      item: itemQuery || {},
      notFound: itemQuery === false,
      structItems,
    });
  };

  save = async () => {
    const { item } = this.state;

    this.setState({ pending: true });
    let result = await this.context.api.q("/maintenance/set", {
      id: item.id === "add" ? null : item.id,
      ship: this.props.shipId,
      structure: item.structure ? item.structure : this.props.structureId,
      label: item.label,
      priority: item.priority,
      description: item.description,
    });
    if (result !== false) {
      this.context.toast("Изменения сохранены", "success");

      if (this.props.onAfterSave) {
        this.props.onAfterSave(item);
      }
      this.context.redirect(`/maint/${this.props.structureId}/${result.id}/`);
    } else {
      this.context.toast("Не удалось сохранить изменения", "error");
      this.setState({ pending: false });
    }
  };

  render() {
    const { pending, item, notFound } = this.state;
    const { shipId, structureId, itemId } = this.props;
    return (
      <>
        <Blocker hAuto on={pending}>
          {notFound && <DefaultNotFound />}
          {item.id && (
            <>
              <div className="pb-3"></div>
              <h5 className="mb-5">
                {item.id === "add" ? (
                  <>Добавление ТО</>
                ) : (
                  <>Редактирование ТО</>
                )}
              </h5>

              <div className="form-group">
                <label>Наименование</label>
                <input
                  id="label"
                  value={item.label || ""}
                  onChange={(e) => this.onChange("label", e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>
              <div className="form-group">
                <label>Описание</label>
                <input
                  id="description"
                  value={item.description || ""}
                  onChange={(e) => this.onChange("description", e.target.value)}
                  type="text"
                  className="form-control"
                />
              </div>

              <div className="form-group">
                <label>Вид, тип ТО</label>
                <select
                  id="structure"
                  value={
                    item.structure ? item.structure : this.props.structureId
                  }
                  onChange={(e) => this.onChange(e.target.id, e.target.value)}
                  className="form-control"
                >
                  {item.id === "add" && <option value=""></option>}
                  {Object.entries(this.state.structItems).map(([id, item]) => (
                    <option value={item.id} key={id}>
                      {" . . ".repeat(item.level)} {item.name}
                    </option>
                  ))}
                </select>
              </div>

              {/* <div className="form-group">
                <label>Приоритет: </label>
                <SuperSelect
                  cache
                  forcePath="/priority"
                  defaultValue={item.priority}
                  onChange={(value) => this.onChange("priority", value)}
                  essence="priority"
                  placeholder="Выберите приоритет..."
                  nameField="name"
                  idField="id"
                />
              </div> */}

              <div className="mb-4 py-2 border-bottom"></div>
              <div className="d-flex justify-content-between">
                <div>
                  <button onClick={this.save} className="btn btn-primary">
                    Сохранить
                  </button>
                  {itemId !== "add" && (
                    <Link
                      to={`/maint/${structureId}/${shipId}/${itemId}/`}
                      className="btn btn-light  ml-2"
                    >
                      Отмена
                    </Link>
                  )}
                </div>
                <div></div>
              </div>
            </>
          )}
        </Blocker>
      </>
    );
  }
}
